import { mediaRef } from '@/services/mediaAssets';

const valleyPhoto01 = mediaRef('adventures/valley-of-fire-2024/084100-crew-img-7694.jpg');
const valleyPhoto02 = mediaRef('adventures/valley-of-fire-2024/090246-crew-img-1051.jpg');
const valleyPhoto03 = mediaRef('adventures/valley-of-fire-2024/090258-crew-img-1052.jpg');
const valleyPhoto04 = mediaRef('adventures/valley-of-fire-2024/090336-crew-img-1054.jpg');
const valleyPhoto05 = mediaRef('adventures/valley-of-fire-2024/091339-smugmug-img-0059.jpg');
const valleyPhoto06 = mediaRef('adventures/valley-of-fire-2024/091813-smugmug-img-0063.jpg');
const valleyPhoto07 = mediaRef('adventures/valley-of-fire-2024/091820-smugmug-img-0992.jpg');
const valleyPhoto08 = mediaRef('adventures/valley-of-fire-2024/092211-smugmug-img-0071.jpg');
const valleyPhoto09 = mediaRef('adventures/valley-of-fire-2024/093100-smugmug-img-0085.jpg');
const valleyPhoto10 = mediaRef('adventures/valley-of-fire-2024/093328-smugmug-img-0088.jpg');
const valleyPhoto11 = mediaRef('adventures/valley-of-fire-2024/093533-crew-img-1058.jpg');
const valleyPhoto12 = mediaRef('adventures/valley-of-fire-2024/093645-smugmug-img-0096.jpg');
const valleyPhoto13 = mediaRef('adventures/valley-of-fire-2024/093704-smugmug-img-0098.jpg');
const valleyPhoto14 = mediaRef('adventures/valley-of-fire-2024/093922-crew-img-1060.jpg');
const valleyPhoto15 = mediaRef('adventures/valley-of-fire-2024/094132-smugmug-img-0108.jpg');
const valleyPhoto16 = mediaRef('adventures/valley-of-fire-2024/094143-crew-img-1063.jpg');
const valleyPhoto17 = mediaRef('adventures/valley-of-fire-2024/094219-crew-img-1066.jpg');
const valleyPhoto18 = mediaRef('adventures/valley-of-fire-2024/094345-crew-img-1067.jpg');
const valleyPhoto19 = mediaRef('adventures/valley-of-fire-2024/094407-smugmug-img-0115.jpg');
const valleyPhoto20 = mediaRef('adventures/valley-of-fire-2024/094440-crew-img-1068.jpg');
const valleyPhoto21 = mediaRef('adventures/valley-of-fire-2024/094520-smugmug-img-0117.jpg');
const valleyPhoto22 = mediaRef('adventures/valley-of-fire-2024/094635-smugmug-img-0120.jpg');
const valleyPhoto23 = mediaRef('adventures/valley-of-fire-2024/094846-crew-img-1072.jpg');
const valleyPhoto24 = mediaRef('adventures/valley-of-fire-2024/095244-smugmug-img-0124.jpg');
const valleyPhoto25 = mediaRef('adventures/valley-of-fire-2024/095301-crew-img-1077.jpg');
const valleyPhoto26 = mediaRef('adventures/valley-of-fire-2024/095505-crew-img-1079.jpg');
const valleyPhoto27 = mediaRef('adventures/valley-of-fire-2024/095523-smugmug-img-0129.jpg');
const valleyPhoto28 = mediaRef('adventures/valley-of-fire-2024/095644-crew-img-1080.jpg');
const valleyPhoto29 = mediaRef('adventures/valley-of-fire-2024/095806-smugmug-img-0134.jpg');
const valleyPhoto30 = mediaRef('adventures/valley-of-fire-2024/095928-smugmug-img-0136.jpg');
const valleyPhoto31 = mediaRef('adventures/valley-of-fire-2024/100150-smugmug-img-0142.jpg');
const valleyPhoto32 = mediaRef('adventures/valley-of-fire-2024/100200-smugmug-img-0144.jpg');
const valleyPhoto33 = mediaRef('adventures/valley-of-fire-2024/100250-smugmug-img-0146.jpg');
const valleyPhoto34 = mediaRef('adventures/valley-of-fire-2024/100310-smugmug-img-0148.jpg');
const valleyPhoto35 = mediaRef('adventures/valley-of-fire-2024/100424-crew-img-1085.jpg');
const valleyPhoto36 = mediaRef('adventures/valley-of-fire-2024/100431-crew-img-1086.jpg');
const valleyPhoto37 = mediaRef('adventures/valley-of-fire-2024/100524-crew-img-1087.jpg');
const valleyPhoto38 = mediaRef('adventures/valley-of-fire-2024/100552-smugmug-img-0156.jpg');
const valleyPhoto39 = mediaRef('adventures/valley-of-fire-2024/100644-smugmug-img-0159.jpg');
const valleyPhoto40 = mediaRef('adventures/valley-of-fire-2024/100700-crew-img-1092.jpg');
const valleyPhoto41 = mediaRef('adventures/valley-of-fire-2024/100812-crew-img-1094.jpg');
const valleyPhoto42 = mediaRef('adventures/valley-of-fire-2024/100852-smugmug-img-0164.jpg');
const valleyPhoto43 = mediaRef('adventures/valley-of-fire-2024/100855-smugmug-img-0165.jpg');
const valleyPhoto44 = mediaRef('adventures/valley-of-fire-2024/101931-crew-img-1100.jpg');
const valleyPhoto45 = mediaRef('adventures/valley-of-fire-2024/102248-crew-img-1104.jpg');
const valleyPhoto46 = mediaRef('adventures/valley-of-fire-2024/103756-crew-img-1110.jpg');
const valleyPhoto47 = mediaRef('adventures/valley-of-fire-2024/104016-crew-img-1113.jpg');
const valleyPhoto48 = mediaRef('adventures/valley-of-fire-2024/104147-crew-img-7737.jpg');
const valleyPhoto49 = mediaRef('adventures/valley-of-fire-2024/110126-smugmug-img-0171.jpg');
const valleyPhoto50 = mediaRef('adventures/valley-of-fire-2024/111622-crew-img-7738.jpg');
const valleyPhoto51 = mediaRef('adventures/valley-of-fire-2024/111929-crew-img-1119.jpg');
const valleyPhoto52 = mediaRef('adventures/valley-of-fire-2024/112136-crew-img-1120.jpg');
const existing1071 = mediaRef('adventures/aws-reinvent-valley-of-fire-offroad-1071.jpg');
const existing1078 = mediaRef('adventures/aws-reinvent-valley-of-fire-offroad-1078.jpg');
const existing1082 = mediaRef('adventures/aws-reinvent-valley-of-fire-offroad-1082.jpg');
const existing1098 = mediaRef('adventures/aws-reinvent-valley-of-fire-offroad-1098.jpg');

const valleyOfFireGallery = [
  {
    id: 'valley-of-fire-084100-crew-img-7694',
    src: valleyPhoto01,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T08:41:00',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-090246-crew-img-1051',
    src: valleyPhoto02,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:02:46',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-090258-crew-img-1052',
    src: valleyPhoto03,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:02:58',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-090336-crew-img-1054',
    src: valleyPhoto04,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:03:36',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-091339-smugmug-img-0059',
    src: valleyPhoto05,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:13:39',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-091813-smugmug-img-0063',
    src: valleyPhoto06,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:18:13',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-091820-smugmug-img-0992',
    src: valleyPhoto07,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:18:20',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-092211-smugmug-img-0071',
    src: valleyPhoto08,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:22:11',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093100-smugmug-img-0085',
    src: valleyPhoto09,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:31:00',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093328-smugmug-img-0088',
    src: valleyPhoto10,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:33:28',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093533-crew-img-1058',
    src: valleyPhoto11,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:35:33',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093645-smugmug-img-0096',
    src: valleyPhoto12,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:36:45',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093704-smugmug-img-0098',
    src: valleyPhoto13,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:37:04',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-093922-crew-img-1060',
    src: valleyPhoto14,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:39:22',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094132-smugmug-img-0108',
    src: valleyPhoto15,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:41:32',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094143-crew-img-1063',
    src: valleyPhoto16,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:41:43',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094219-crew-img-1066',
    src: valleyPhoto17,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:42:19',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094345-crew-img-1067',
    src: valleyPhoto18,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:43:45',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094407-smugmug-img-0115',
    src: valleyPhoto19,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:44:07',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094440-crew-img-1068',
    src: valleyPhoto20,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:44:40',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094520-smugmug-img-0117',
    src: valleyPhoto21,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:45:20',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094635-smugmug-img-0120',
    src: valleyPhoto22,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:46:35',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-existing-1071',
    src: existing1071,
    alt: 'Reckon crew members watching a Jeep crawl through the red rocks',
    caption: 'The crew found the perfect vantage point to watch the next obstacle.',
    capturedAt: '2024-12-06T09:48:05',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-094846-crew-img-1072',
    src: valleyPhoto23,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:48:46',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095244-smugmug-img-0124',
    src: valleyPhoto24,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:52:44',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095301-crew-img-1077',
    src: valleyPhoto25,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:53:01',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-existing-1078',
    src: existing1078,
    alt: 'Jeeps following an off-road trail through the Valley of Fire landscape',
    caption: 'Following the convoy deeper into the red-rock trail.',
    capturedAt: '2024-12-06T09:53:21',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095505-crew-img-1079',
    src: valleyPhoto26,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:55:05',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095523-smugmug-img-0129',
    src: valleyPhoto27,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:55:23',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095644-crew-img-1080',
    src: valleyPhoto28,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T09:56:44',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095806-smugmug-img-0134',
    src: valleyPhoto29,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:58:06',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-095928-smugmug-img-0136',
    src: valleyPhoto30,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T09:59:28',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100150-smugmug-img-0142',
    src: valleyPhoto31,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:01:50',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100200-smugmug-img-0144',
    src: valleyPhoto32,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:02:00',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100250-smugmug-img-0146',
    src: valleyPhoto33,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:02:50',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100310-smugmug-img-0148',
    src: valleyPhoto34,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:03:10',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-existing-1082',
    src: existing1082,
    alt: 'Two lifted Jeeps navigating red sandstone obstacles in Valley of Fire',
    caption: 'The Jeeps crawling across the red sandstone in Valley of Fire.',
    capturedAt: '2024-12-06T10:03:10.500',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100424-crew-img-1085',
    src: valleyPhoto35,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:04:24',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100431-crew-img-1086',
    src: valleyPhoto36,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:04:31',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100524-crew-img-1087',
    src: valleyPhoto37,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:05:24',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100552-smugmug-img-0156',
    src: valleyPhoto38,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:05:52',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100644-smugmug-img-0159',
    src: valleyPhoto39,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:06:44',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100700-crew-img-1092',
    src: valleyPhoto40,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:07:00',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100812-crew-img-1094',
    src: valleyPhoto41,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:08:12',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100852-smugmug-img-0164',
    src: valleyPhoto42,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:08:52',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-100855-smugmug-img-0165',
    src: valleyPhoto43,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T10:08:55',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-existing-1098',
    src: existing1098,
    alt: 'A Reckon crew member standing beside a red Jeep beneath an American flag',
    caption: 'A quick stop beside the Jeep before heading back onto the rocks.',
    capturedAt: '2024-12-06T10:10:12',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-101931-crew-img-1100',
    src: valleyPhoto44,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:19:31',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-102248-crew-img-1104',
    src: valleyPhoto45,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:22:48',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-103756-crew-img-1110',
    src: valleyPhoto46,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:37:56',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-104016-crew-img-1113',
    src: valleyPhoto47,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:40:16',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-104147-crew-img-7737',
    src: valleyPhoto48,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T10:41:47',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-110126-smugmug-img-0171',
    src: valleyPhoto49,
    alt: 'A Jeep navigating the red-rock terrain during the Valley of Fire off-road tour',
    caption: 'Rock crawling through the Valley of Fire.',
    capturedAt: '2024-12-06T11:01:26',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-111622-crew-img-7738',
    src: valleyPhoto50,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T11:16:22',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-111929-crew-img-1119',
    src: valleyPhoto51,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T11:19:29',
    position: 'center center',
  },
  {
    id: 'valley-of-fire-112136-crew-img-1120',
    src: valleyPhoto52,
    alt: 'The Reckon crew exploring the Valley of Fire Jeep trail',
    caption: 'The Reckon crew on the Valley of Fire off-road adventure.',
    capturedAt: '2024-12-06T11:21:36',
    position: 'center center',
  },
];

export default valleyOfFireGallery;
